<div class="layout-ParentDiv innerDiv editeUser">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <p-toast key="toastmsg" position="top-right"></p-toast>

                    <form [formGroup]="userForm" *ngIf="this.userForm" (ngSubmit)="onSubmit()">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div
                                class="p-field p-col-12 div-border p-p-0 d-flex align-items-center justify-content-between">
                                <h3 class="head-page-title">
                                    Edit Player
                                </h3>
                                <div style="display: flex; justify-content: flex-end;">
                                    <p-splitButton icon="pi pi-ellipsis-h" [model]="userMenuList" appendTo="body"
                                        styleClass="moreBtn" pTooltip="More Menu " tooltipPosition="bottom"
                                        (onClick)="listMenus()"></p-splitButton>
                                </div>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4">
                                    <label for="firstName">First Name <span class="mandatory-fields">*</span></label>
                                    <input formControlName="firstName" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                                    <div *ngIf="((submitted && f.firstName.errors) || (f.firstName.errors && (f.firstName.dirty || f.firstName.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.firstName.errors.required">First Name is required
                                        </div>
                                        <div *ngIf="!f.firstName.errors.required && f.firstName.errors">Only
                                            Alphabets allowed.</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="lastName">Last Name <span class="mandatory-fields">*</span></label>
                                    <input formControlName="lastName" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                    <div *ngIf="((submitted && f.lastName.errors) || (f.lastName.errors && (f.lastName.dirty || f.lastName.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                        <div *ngIf="!f.lastName.errors.required && f.lastName.errors">Only
                                            Alphabets allowed.</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="email">Email ID <span class="mandatory-fields">*</span></label>
                                    <input formControlName="email" type="text" pInputText
                                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Email is
                                            required</div>
                                        <div *ngIf="f.email.errors.email">Enter valid email
                                            address</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="mobileNumber">Mobile Number <span class="mandatory-fields">*</span></label>
                                    <input formControlName="mobileNumber" type="text" maxlength="10" pInputText
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
                                    <div *ngIf="((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.mobileNumber.errors.required">Mobile Number is
                                            required</div>
                                        <div *ngIf="f.mobileNumber.errors.pattern">Please Check Mobile
                                            Number</div>
                                    </div>
                                </div>
                                <!-- <div class="p-field p-col-4">
                        <label for="mobileNumber">Mobile Number</label>
                        <input formControlName="mobileNumber" type="text" minlength="10"
                            maxlength="10" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
                        <div *ngIf="submitted && f.mobileNumber.errors"
                            class="invalid-feedback">
                            <div *ngIf="f.mobileNumber.$error.required">Mobile
                                Number is required <br>Please Check Mobile Number</div>
                            <div
                                *ngIf="!f.mobileNumber.errors.required && f.mobileNumber.errors">
                                Please Check
                                Mobile Number</div>
                        </div>
                    </div> -->
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="textarea">Gender <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="gender" [options]="genders" formControlName="gender"
                                        placeholder="Select" optionLabel="name"
                                        (ngModelChange)="onGenderSelect($event)"></p-dropdown>
                                    <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                                        <div *ngIf="f.gender.errors.required">Please, Select
                                            Gender</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="dob">DOB <span class="mandatory-fields">*</span></label>
                                    <!-- <p-calendar #pCalendarId  class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"  [(ngModel)]="calvalue" ></p-calendar> -->
                                    <!-- <p-calendar formControlName="dob" class="p-calendar"
                            placeholder="Select Date Of Birth" monthNavigator="true"
                            yearNavigator="true" yearRange="{{yearRange}}" inputId="calendar"
                            dateFormat="dd-mm-yy" [showIcon]="true" (onSelect)="setDOB($event)"
                            [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"></p-calendar> -->
                                    <p-calendar formControlName="dob" [showIcon]="true" inputId="icon"
                                        [readonlyInput]="true" placeholder="Birth Date" monthNavigator="true"
                                        yearNavigator="true" yearRange="{{yearRange}}" class="p-calendar"
                                        inputId="calendar" [defaultDate]="defaultDate" dateFormat="dd-mm-yy"
                                        [showIcon]="true"
                                        [ngClass]="{ 'is-invalid': submitted && f.dob.invalid}"></p-calendar>
                                    <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                        <div *ngIf="f.dob.errors.required">Please enter DOB</div>

                                    </div>


                                    <!-- <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                            <div *ngIf="f.dob.errors.required">Please
                                enter DOB</div>
                        </div> -->
                                </div>
                                <!-- <div class="p-field p-col-4">
                <label>Password</label>
                <input type="password" formControlName="password" pInputText [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                    <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                </div>
            </div>
            <div class="p-field p-col-4">
                <label>Confirm Password</label>
                <input type="password" formControlName="confirmPassword" pInputText [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                    <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</div>
                </div>
            </div> -->
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="country">Country <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="country" [filter]="true" [options]="countrylist"
                                        formControlName="country" (onChange)="getStates('true',$event)"
                                        placeholder="Select" optionLabel="name"></p-dropdown>
                                    <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                        <div *ngIf="f.country.errors.required">Please,
                                            Select Country</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="state">State <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="state" [filter]="true" [options]="statelist"
                                        formControlName="state" (onChange)="getCities('true', $event)"
                                        placeholder="Select" optionLabel="name"></p-dropdown>
                                    <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                        <div *ngIf="f.state.errors.required">Please, Select
                                            State</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="city">City <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="city" [filter]="true" [options]="citylist"
                                        formControlName="city" (onChange)="onCitySelect($event)" placeholder="Select"
                                        optionLabel="name"></p-dropdown>
                                    <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                        <div *ngIf="f.city.errors.required">Please, Select
                                            City</div>
                                    </div>
                                </div>

                                <div class="p-field p-col-4">
                                    <label for="zipCode">ZIP CODE <span class="mandatory-fields">*</span></label>
                                    <input formControlName="zipcode" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }">
                                    <div *ngIf="((submitted && f.zipcode.errors) || (f.zipcode.errors && (f.zipcode.dirty || f.zipcode.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.zipcode.errors.required">ZipCode is
                                            required</div>
                                        <div *ngIf="f.zipcode.errors.pattern">Please Check ZipCode</div>
                                    </div>
                                </div>


                                <div class="p-field p-col-8">
                                    <label for="zipCode">ADDRESS <span class="mandatory-fields">*</span></label>
                                    <textarea inputId="textarea" rows="3" cols="30" class="form-control"
                                        formControlName="address" pInputTextarea></textarea>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 mb-0">
                                    <div class="statusdiv ">
                                        <label for="status">Status</label>
                                        <div class="swichTable">
                                            <p-inputSwitch formControlName="status">

                                            </p-inputSwitch>
                                        </div>
                                    </div>
                                    <!-- <label for="status">Status</label>
                                    <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                        placeholder="Select" optionLabel="label"
                                        (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Please Select
                                            Status</div>
                                    </div> -->
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                                <div class="p-field p-col-12 uploadBtn mb-0">
                                    <div class="subTitleLable">
                                        <h4>Profile Photo</h4>
                                    </div>
                                    <!-- <p-fileUpload name="myfiles[]" chooseLabel="Upload" uploadLabel="Show data"
                                        cancelLabel="Cancel" accept="image/*" maxFileSize="1000000" auto="auto"
                                        customUpload="true" (uploadHandler)="picUploader($event)"
                                        (onRemove)="removeFile($event)">

                                        <ng-template pTemplate="content">

                                        </ng-template>
                                    </p-fileUpload> -->
                                    <p-fileUpload #fileUpload mode="advanced" name="myfiles[]" chooseLabel="Upload" uploadLabel="Show data" cancelLabel="Cancel"
                                        accept="image/*" maxFileSize="1000000" auto="false" customUpload="true"
                                        (onSelect)="onFileSelect($event)" (onRemove)="removeFile($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload>
                                    <div class="error-msg" *ngIf="notproduct">
                                        Upload
                                    </div>
                                    <div class="p-fluid p-formgrid p-grid baner-image-update ">
                                        <div class="p-field p-col-12">
                                            <div *ngIf="showProfile" class="column banner-images col mt-3">
                                                <img class="thumbnail-image" src="{{imageProfile}}" />
                                                <ul class="actionList">
                                                    <li>
                                                        <button type="button" class="editBtn"><img
                                                                src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                                    </li>
                                                    <li>
                                                        <button type="button" class="deleteBtn"><img
                                                                src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="instruction">
                                        <p>Instructions: </p>
                                        <ul>
                                            <li>1) The width and height of the Profile should be 512px and
                                                512px, with a maximum size of 1 Mb.</li>
                                            <li>2) The width and height of the page top banners should be 2031px and
                                                290px, with a maximum size of 1 Mb.</li>
                                        </ul>
                                    </div>
                                    <div class="p-field p-col-12">
                                        <div class="lineborderHR">
                                            <hr>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="p-fluid p-formgrid p-grid">
            
            

        </div> -->
                            <!-- <div class="p-fluid p-formgrid p-grid"> -->


                            <!-- <div class="p-field p-col-4">
                <label for="dob">DOB</label>
                <p-calendar [readonlyInput]="true" placeholder="Select Date Of Birth" formControlName="dob"
                    class="p-column-filter" monthNavigator="true" yearNavigator="true" yearRange="{{yearRange}}"
                    inputId="calendar" dateFormat="dd/mm/yy" [readonlyInput]="true" [showIcon]="true"
                    (onSelect)="setDOB($event)" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }">
                </p-calendar>
                <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                    <div *ngIf="f.dob.errors.required">Please, Enter Dob</div>
                </div>
            </div> -->
                            <!-- <div class="p-field p-col-4">
                <label for="weddingDate">Wedding Date</label>
                <p-calendar placeholder="Select Wedding Date" formControlName="weddingDate"  class="p-column-filter" inputId="calendar"
                    dateFormat="dd/mm/yy" [readonlyInput]="true" [showIcon]="true" (onSelect)="setWeddingDate($event)"></p-calendar>
            </div> -->
                            <!-- </div> -->
                            <div class="p-fluid p-formgrid p-grid w-100">


                                <!-- <div class="Upcard" *ngFor="let url of urls | slice:1">
                        <img [src]="{{imageProfile}}">
                        <span class="delete-entry" style="cursor: pointer;" (click)="deleteImage(url)">x</span>
                    </div> -->

                                <!-- <div class="p-field p-col-4">
                            <div class="user-list">
                                <ul>
                                    <li *ngFor="let userCategory of userCategories"
                                        [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                        <label for="{{userCategory.slug}}" class="{{userCategory.slug}}">
                                            <div class="box">
                                                <div class="role-lis-details">
                                                    <div class="user-name"> {{userCategory.name}} </div>
                                                </div>
                                                <p-radioButton formControlName="{{userCategory.slug}}"
                                                    [value]="userCategory.status" inputId="{{userCategory.slug}}"
                                                    (onClick)="onUserCategorySelect(userCategory, $event)">
                                                </p-radioButton>
                                                
                                            </div>
                                        </label>
        
                                    </li>
                                </ul>
                                <div *ngIf="showCategoryError">
                                    <div>
                                        <span> Please Select User Category</span>
                                    </div>
                                </div>
        
                            </div>
                        </div> -->

                            </div>

                            <div class="p-fluid p-formgrid p-grid w-100">
                                <div class="p-field p-col-4 mb-0">
                                    <div class="lbl-custom pb-0 list-checkbox-div">
                                        <label class="heading-div">Select Role</label>
                                        <span *ngFor="let userCategory of userCategories" class="field-checkbox">
                                            <label class="radio-custom" style="width: 100%;">
                                                <p-radioButton formControlName="{{userCategory.slug}}"
                                                    [value]="userCategory"
                                                    (onClick)="onCategorySelect(userCategory, $event)">
                                                </p-radioButton>
                                                &nbsp;&nbsp; {{userCategory.name}}
                                            </label>
                                        </span>
                                    </div>
                                </div>
                                <!-- <div class="p-field p-col-4">
                            <div class="user-list mt-0">
                                <ul>
                                    <li *ngFor="let userCategory of userCategories"
                                        [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                        <label for="{{userCategory.slug}}" class="{{userCategory.slug}}">
                                            <div class="box">
                                                <div class="role-lis-details">
                                                    <div class="user-name"> {{userCategory.name}} </div>
                                                </div>
                                                <p-radioButton formControlName="{{userCategory.slug}}"
                                                    [value]="userCategory.status" inputId="{{userCategory.slug}}"
                                                    (onClick)="onUserCategorySelect(userCategory, $event)">
                                                </p-radioButton>
                                                
                                            </div>
                                        </label>
        
                                    </li>
                                </ul>
                                <div *ngIf="showCategoryError">
                                    <div>
                                        <span> Please Select User Category</span>
                                    </div>
                                </div>
        
                            </div>
                        </div> -->

                                <div class="p-field p-col-4" *ngIf="showRating">
                                    <label for="zipcode">Pro Player Ratings <span
                                            class="mandatory-fields">*</span></label>
                                    <input formControlName="proplayerRating" type="text" pInputText
                                        class="form-control">

                                </div>

                            </div>
                            <div class="p-field p-col-12">
                                <div class="lineborderHR">
                                    <hr>
                                </div>
                            </div>

                            <div class="p-field p-col-12 uploadBtn mb-0">
                                <div class="subTitleLable">
                                    <h4> Player Playing Video</h4>
                                </div>
                                <p-fileUpload name="myfile[]" maxFileSize="{{videoSize}}" customUpload="true"
                                    chooseIcon="pi pi-upload" (uploadHandler)="videoUploader($event)" accept=".mp4"
                                    auto="auto" chooseLabel="Upload">
                                </p-fileUpload>
                            </div>
                            <div class="p-fluid p-formgrid p-grid baner-image-update ">
                                <div class="p-field p-col-12">
                                    <div *ngIf="selectedPlayerVideo" class="column banner-images col mt-3">
                                        <video class="thumbnail-image" width="100%" controls="" loop="">
                                            <source type="video/mp4" src="{{selectedPlayerVideo}}" />
                                        </video>
                                        <ul class="actionList">
                                            <li>
                                                <button class="editBtn"><img
                                                        src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                            </li>
                                            <li>
                                                <button class="deleteBtn"><img
                                                        src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                            </li>
                                        </ul>
                                    </div>
                                     
                                </div>
                            </div>
                            <div class="p-field p-col-12">
                                <div class="lineborderHR">
                                    <hr>
                                </div>
                            </div>



                            <div class="p-field p-col-12 left-div">
                                <div class="video-approvel-list mb-0">
                                    <div class="subTitleLable">
                                        <h4> Approve Or Reject ?</h4>
                                    </div>
                                    <div class="list approved">
                                        <h5 class="w-100">Video Approve</h5>
                                        <div class="checkBox-div">
                                            <div *ngFor="let flag of acceptOrReject" class="field-checkbox">
                                                <p-radioButton [inputId]="flag.key" [value]="flag.key"
                                                    (click)="onApproveclick( flag.name )"
                                                    formControlName="isplayerVideoApproved"></p-radioButton>
                                                <label [for]="flag.key" class="ml-2">{{ flag.name }}</label>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- <div class="list">
                                OR
                            </div> -->
                                    <div class="list reject">
                                        <h5 class="w-100">Video Reject</h5>
                                        <div class="checkBox-div">
                                            <div *ngFor="let flag of acceptOrReject" class="field-checkbox">
                                                <p-radioButton [inputId]="flag.key" [value]="flag.key"
                                                    (click)="showRejectmodal(flag.name)"
                                                    formControlName="isPlayerVideoRejected"></p-radioButton>
                                                <label [for]="flag.key" class="ml-2">{{ flag.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <!-- <p-dropdown inputId="status" [options]="approvedstatuses" formControlName="videostatus"
                            placeholder="Select" optionLabel="label"
                            (ngModelChange)="onVideoStatusSelect($event)"></p-dropdown>
                        <div *ngIf="submitted && f.videostatus.errors" class="invalid-feedback">
                            <div *ngIf="f.videostatus.errors.required">Please Select Video Approval Status</div>
                        </div> -->
                            </div>



                        </div>
                        <div class="p-field  p-col-12 right-div p-p-0 mt-3">
                            <div class="subTitleLable">
                                <h4> Rejected Video List</h4>
                            </div>
                            <div class="maintableDiv">
                                <div class="tableParanet">
                                    <p-table [value]="rejectedReasonList" [tableStyle]="{'min-width': '100%'}">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Reason</th>
                                                <th>Date Of Rejection</th>
                                                <th>Rejected Video</th>
                                            </tr>
                                            <tr>
                                                <th><input type="text"></th>
                                                <th><input type="text"></th>
                                                <th><input type="text"></th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rejectedReasonList>
                                            <tr>
                                                <td>{{rejectedReasonList.comment}}</td>
                                                <td>{{rejectedReasonList.dateOfRejection|date:'MMMM d, y, h:mm a' }}
                                                </td>
                                                <td>
                                                    <video class="" width="125px" height="64px" controls="" loop="">
                                                        <source type="video/mp4"
                                                            src="{{rejectedReasonList.rejectedvideoClip}}" />
                                                    </video>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <!-- <ng-template pTemplate="summary">
                                            <div class="flex align-items-center justify-content-between">
                                                In total there are {{rejectedReasonList ? rejectedReasonList.length : 0
                                                }}
                                                rejected reason .
                                            </div>
                                        </ng-template> -->
                                    </p-table>
                                </div>
                            </div>

                        </div>
                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                            <div class="p-formgrid p-grid">

                                <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                                <!-- <button pButton pRipple label="" icon="pi pi-times" type="reset" (click)="onReset()"></button> -->
                                <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                    class="cancel-btn p-mr-3" (click)="backLink()" style="width:auto;"></button>
                                <button pButton pRipple label="Save" icon="pi pi-check" class=" save-btn "
                                    style="width:auto;"></button>
                            </div>
                        </div>
                    </form>


                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <p-dialog
    [(visible)]="cropDialog"
    [closable]="false"
    [modal]="true"
    [appendTo]="'body'"
    [style]="{ width: '660px' }"
    styleClass="custom-crop-dialog">

    <ng-template pTemplate="header">
        <div class="crop-header-wrapper">
            <div class="crop-header-icon-box">
                <i class="pi pi-image header-icon"></i>
            </div>

            <div class="crop-header-text">
                <h5 class="crop-dialog-title">{{ cropDialogTitle }}</h5>
                <p class="crop-dialog-subtitle">
                    {{ cropDialogSubtitle }}
                </p>
            </div>
        </div>
    </ng-template>

    <div class="crop-dialog-content-wrapper">

        <div class="crop-toolbar-bar mb-3">
            <div class="toolbar-hint">
                <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                <span>Zoom & Scale</span>
            </div>

            <div class="zoom-actions">

                <button
                    type="button"
                    pButton
                    icon="pi pi-search-plus"
                    label="Zoom In"
                    class="crop-btn zoom-btn"
                    (click)="zoomIn()">
                </button>

                <button
                    type="button"
                    pButton
                    icon="pi pi-search-minus"
                    label="Zoom Out"
                    class="crop-btn zoom-btn"
                    (click)="zoomOut()">
                </button>

                <button
                    type="button"
                    pButton
                    icon="pi pi-refresh"
                    label="Reset"
                    class="crop-btn reset-btn"
                    (click)="resetZoom()">
                </button>

            </div>
        </div>

        <div class="cropper-frame mb-3">

            <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="512 / 512"
                [resizeToWidth]="512"
                [resizeToHeight]="512"
                [transform]="transform"
                format="jpeg"
                (imageCropped)="imageCropped($event)">
            </image-cropper>

        </div>

        <div class="error-msg crop-error-msg"
            *ngIf="croppedImageError">

            {{ croppedImageError }}

        </div>

        <div class="cropped-preview-box"
            *ngIf="croppedImage">

            <div class="preview-header">

                <div class="preview-title">
                    <i class="pi pi-eye mr-2 text-primary"></i>
                    <span>Live Cropped Preview</span>
                </div>

                <span class="preview-ratio-badge">
                    {{ cropPreviewLabel }}
                </span>

            </div>

            <div class="preview-img-container">
                <img
                    [src]="croppedImage"
                    alt="Cropped Preview"
                    class="preview-img" />
            </div>

        </div>

    </div>

    <ng-template pTemplate="footer">

        <div class="dialog-footer-actions">

            <button
                type="button"
                pButton
                label="Cancel"
                icon="pi pi-times"
                class="cancel-action-btn"
                (click)="onCropCancel()">
            </button>

            <button
                type="button"
                pButton
                label="Use Image"
                icon="pi pi-check"
                class="use-image-btn"
                (click)="applyCrop()"
                [disabled]="!!croppedImageError || !croppedImage">
            </button>

        </div>

    </ng-template>

</p-dialog>
</div>


<p-dialog header="Mention Reject Reason" [(visible)]="rejectModal" (onHide)="onRejectModalClose()" [modal]="true"
    [style]="{ width: '400px' }" [draggable]="false" [resizable]="false" class="modal-payment-select" id="rejectionModal">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="p-grid">
            <div class="col-12 mt-3">
                	<label for="comment">
					Reason
				</label>
                <div class="form-div">
                    <textarea pInputTextarea rows="5" formControlName="comment"
                        [ngClass]="{ 'is-invalid': submitted && f.comment.errors }"></textarea>
                    <div *ngIf="((submitted && f.comment.errors) || (f.comment.errors && (f.comment.dirty || f.comment.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.comment.errors.required">
                            Reason is required</div>
                    </div>
                </div>
            </div>
           	<div class="modalFooter d-flex justify-content-center">
                <button class="btn btn-danger" type="submit"> Reject </button>
            </div>
        </div>
    </form>
</p-dialog>
